function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useMemo } from 'react';
import c from 'classnames';
import ReactDomServer from 'react-dom/server';
import { useClearRefinements, useCurrentRefinements, useRefinementList } from 'react-instantsearch';
import { FormSelect } from '@uncinc/uncinc-react-kitchen-sink';
const SearchFacetRefinementSelect = props => {
  const {
    attribute,
    limit = 100,
    className,
    itemClassName,
    multiple = true,
    searchable = true,
    ...restProps
  } = props;
  const {
    items: currentRefinements
  } = useCurrentRefinements({
    includedAttributes: [attribute]
  });
  const {
    refine: clear
  } = useClearRefinements({
    includedAttributes: [attribute]
  });
  const {
    items,
    refine,
    canRefine,
    searchForItems
  } = useRefinementList({
    ...props,
    limit,
    showMore: false
  });
  const classNames = c('Searchkit__Facet__RefinementSelect', className);
  const itemClassNames = c('Searchkit__Facet__RefinementSelect__item', itemClassName);
  const options = useMemo(() => items.map(item => ({
    value: item.value,
    label: ReactDomServer.renderToString(/*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label"
    }, /*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label__label"
    }, item.label), /*#__PURE__*/React.createElement("span", {
      className: "Searchkit__Facet__label__count"
    }, item.count))),
    disabled: item.count === 0
  })), [items]);
  const defaultValue = useMemo(() => {
    const currentOptions = items.filter(item => item.isRefined);
    return currentOptions?.map(option => option.value);
  }, [items]);
  if (!canRefine) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FormSelect, _extends({}, restProps, {
    fieldName: `refinementList_${attribute}`,
    options: options,
    defaultValue: defaultValue,
    multiple: multiple,
    wrapperClassName: classNames,
    className: itemClassNames
    // onInputChange is passed through all the way to SelectStyled, used in KS.
    ,
    onInputChange: query => {
      if (searchable) {
        searchForItems(query);
      }
    },
    onChange: newSelection => {
      // If new selection is empty, clear refinement.
      if (!newSelection || newSelection.length === 0) {
        clear();
        return;
      }

      // Below logic is in place because the refinements
      // can change outside of this component's scope.
      // For example, when you use the ActiveFacets component, and delete
      // an item through there.

      // Because we call this onChange, the currentRefinements haven't changed yet.
      const previousSelection = currentRefinements[0]?.refinements.map(refinement => refinement.value) || [];

      // Per default, use the last item of the new selection.
      let itemToRefine = newSelection[newSelection.length - 1];

      // This happens if you delete an item, and add one again.
      if (previousSelection.length === newSelection.length) {
        const addedItem = newSelection.find(item => !previousSelection.includes(item));
        if (addedItem) {
          itemToRefine = addedItem;
        }
      }

      // Compare previous selection with new selection.
      // If new selection array is larger than previous selection array,
      // it means an item has been added, thus, refine that item.
      if (newSelection.length > previousSelection.length) {
        itemToRefine = newSelection[newSelection.length - 1];
      }

      // If new selection array is smaller than previous selection array,
      // it means an item has been deleted, thus, refine the deleted item.
      if (newSelection.length < previousSelection.length) {
        const deletedItem = previousSelection.find(item => !newSelection.includes(item));
        if (deletedItem) {
          itemToRefine = deletedItem;
        }
      }
      refine(itemToRefine);
    }
  }));
};
export default SearchFacetRefinementSelect;